"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAILS_MORE_APPS_RESET = exports.DETAILS_MORE_APPS_FETCH_FAILED = exports.DETAILS_MORE_APPS_FETCH_RECEIVED = exports.DETAILS_MORE_APPS_FETCH_REQUESTED = exports.REVIEW_REPORT_REPLY_FAILED = exports.REVIEW_REPORT_REPLY_RECEIVED = exports.REVIEW_REPORT_REPLY_REQUESTED = exports.REVIEW_REPORT_FAILED = exports.REVIEW_REPORT_RECEIVED = exports.REVIEW_REPORT_REQUESTED = exports.REVIEW_HELPFUL_FAILED = exports.REVIEW_HELPFUL_RECEIVED = exports.REVIEW_HELPFUL_REQUESTED = exports.REVIEWS_STATS_RESET = exports.REVIEWS_STATS_FAILED = exports.REVIEWS_STATS_RECEIVED = exports.REVIEWS_STATS_REQUESTED = exports.REVIEWS_FETCH_RESET = exports.REVIEWS_FETCH_FAILED = exports.REVIEWS_FETCH_RECEIVED = exports.REVIEWS_FETCH_REQUESTED = exports.REVIEW_WRITE_FAILED = exports.REVIEW_WRITE_RECEIVED = exports.REVIEW_WRITE_REQUESTED = exports.DETAILS_FETCH_FAILED = exports.DETAILS_FETCH_RECEIVED = exports.DETAILS_FETCH_REQUESTED = exports.ALL_COLLECTIONS_COLLECTION_FETCH_FAILED = exports.ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED = exports.ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED = exports.HUB_FETCH_FAILED = exports.HUB_FETCH_RECEIVED = exports.HUB_FETCH_REQUESTED = exports.EMAIL_ADMIN_FAILED = exports.EMAIL_ADMIN_RECEIVED = exports.EMAIL_ADMIN_REQUESTED = exports.ADMIN_FETCH_FAILED = exports.ADMIN_FETCH_RECEIVED = exports.ADMIN_FETCH_REQUESTED = exports.APP_CONNECTION_GENERIC_FAILED = exports.APP_CONNECTION_INVALID_LICENSE = exports.APP_CONNECTION_ADMIN_REQUIRED = exports.APP_CONNECTION_CANCELLED = exports.APP_INTEGRATIONS_FAILED = exports.APP_INTEGRATIONS_RECEIVED = exports.APP_INTEGRATIONS_REQUESTED = exports.LOGIN_VERIFY_CHECKED = exports.INITIALIZE_ADMIN_AUTH = exports.INITIALIZE_AUTH = exports.APP_STARTED = void 0;
var APP_STARTED = 'APP_STARTED';
exports.APP_STARTED = APP_STARTED;
var INITIALIZE_AUTH = 'INITIALIZE_AUTH';
exports.INITIALIZE_AUTH = INITIALIZE_AUTH;
var INITIALIZE_ADMIN_AUTH = 'INITIALIZE_ADMIN_AUTH';
exports.INITIALIZE_ADMIN_AUTH = INITIALIZE_ADMIN_AUTH;
var LOGIN_VERIFY_CHECKED = 'LOGIN_VERIFY_CHECKED';
exports.LOGIN_VERIFY_CHECKED = LOGIN_VERIFY_CHECKED;
var APP_INTEGRATIONS_REQUESTED = 'APP_INTEGRATIONS_REQUESTED';
exports.APP_INTEGRATIONS_REQUESTED = APP_INTEGRATIONS_REQUESTED;
var APP_INTEGRATIONS_RECEIVED = 'APP_INTEGRATIONS_RECEIVED';
exports.APP_INTEGRATIONS_RECEIVED = APP_INTEGRATIONS_RECEIVED;
var APP_INTEGRATIONS_FAILED = 'APP_INTEGRATIONS_FAILED';
exports.APP_INTEGRATIONS_FAILED = APP_INTEGRATIONS_FAILED;
var APP_CONNECTION_CANCELLED = 'APP_CONNECTION_CANCELLED';
exports.APP_CONNECTION_CANCELLED = APP_CONNECTION_CANCELLED;
var APP_CONNECTION_ADMIN_REQUIRED = 'APP_CONNECTION_ADMIN_REQUIRED';
exports.APP_CONNECTION_ADMIN_REQUIRED = APP_CONNECTION_ADMIN_REQUIRED;
var APP_CONNECTION_INVALID_LICENSE = 'APP_CONNECTION_INVALID_LICENSE';
exports.APP_CONNECTION_INVALID_LICENSE = APP_CONNECTION_INVALID_LICENSE;
var APP_CONNECTION_GENERIC_FAILED = 'APP_CONNECTION_GENERIC_FAILED';
exports.APP_CONNECTION_GENERIC_FAILED = APP_CONNECTION_GENERIC_FAILED;
var ADMIN_FETCH_REQUESTED = 'ADMIN_FETCH_REQUESTED';
exports.ADMIN_FETCH_REQUESTED = ADMIN_FETCH_REQUESTED;
var ADMIN_FETCH_RECEIVED = 'ADMIN_FETCH_RECEIVED';
exports.ADMIN_FETCH_RECEIVED = ADMIN_FETCH_RECEIVED;
var ADMIN_FETCH_FAILED = 'ADMIN_FETCH_FAILED';
exports.ADMIN_FETCH_FAILED = ADMIN_FETCH_FAILED;
var EMAIL_ADMIN_REQUESTED = 'EMAIL_ADMIN_REQUESTED';
exports.EMAIL_ADMIN_REQUESTED = EMAIL_ADMIN_REQUESTED;
var EMAIL_ADMIN_RECEIVED = 'EMAIL_ADMIN_RECEIVED';
exports.EMAIL_ADMIN_RECEIVED = EMAIL_ADMIN_RECEIVED;
var EMAIL_ADMIN_FAILED = 'EMAIL_ADMIN_FAILED';
exports.EMAIL_ADMIN_FAILED = EMAIL_ADMIN_FAILED;
var HUB_FETCH_REQUESTED = 'HUB_FETCH_REQUESTED';
exports.HUB_FETCH_REQUESTED = HUB_FETCH_REQUESTED;
var HUB_FETCH_RECEIVED = 'HUB_FETCH_RECEIVED';
exports.HUB_FETCH_RECEIVED = HUB_FETCH_RECEIVED;
var HUB_FETCH_FAILED = 'HUB_FETCH_FAILED';
exports.HUB_FETCH_FAILED = HUB_FETCH_FAILED;
var ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED = 'ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED';
exports.ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED = ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED;
var ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED = 'ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED';
exports.ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED = ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED;
var ALL_COLLECTIONS_COLLECTION_FETCH_FAILED = 'ALL_COLLECTIONS_COLLECTION_FETCH_FAILED';
exports.ALL_COLLECTIONS_COLLECTION_FETCH_FAILED = ALL_COLLECTIONS_COLLECTION_FETCH_FAILED;
var DETAILS_FETCH_REQUESTED = 'DETAILS_FETCH_REQUESTED';
exports.DETAILS_FETCH_REQUESTED = DETAILS_FETCH_REQUESTED;
var DETAILS_FETCH_RECEIVED = 'DETAILS_FETCH_RECEIVED';
exports.DETAILS_FETCH_RECEIVED = DETAILS_FETCH_RECEIVED;
var DETAILS_FETCH_FAILED = 'DETAILS_FETCH_FAILED';
exports.DETAILS_FETCH_FAILED = DETAILS_FETCH_FAILED;
var REVIEW_WRITE_REQUESTED = 'REVIEW_WRITE_REQUESTED';
exports.REVIEW_WRITE_REQUESTED = REVIEW_WRITE_REQUESTED;
var REVIEW_WRITE_RECEIVED = 'REVIEW_WRITE_RECEIVED';
exports.REVIEW_WRITE_RECEIVED = REVIEW_WRITE_RECEIVED;
var REVIEW_WRITE_FAILED = 'REVIEW_WRITE_FAILED';
exports.REVIEW_WRITE_FAILED = REVIEW_WRITE_FAILED;
var REVIEWS_FETCH_REQUESTED = 'REVIEWS_FETCH_REQUESTED';
exports.REVIEWS_FETCH_REQUESTED = REVIEWS_FETCH_REQUESTED;
var REVIEWS_FETCH_RECEIVED = 'REVIEWS_FETCH_RECEIVED';
exports.REVIEWS_FETCH_RECEIVED = REVIEWS_FETCH_RECEIVED;
var REVIEWS_FETCH_FAILED = 'REVIEWS_FETCH_FAILED';
exports.REVIEWS_FETCH_FAILED = REVIEWS_FETCH_FAILED;
var REVIEWS_FETCH_RESET = 'REVIEWS_FETCH_RESET';
exports.REVIEWS_FETCH_RESET = REVIEWS_FETCH_RESET;
var REVIEWS_STATS_REQUESTED = 'REVIEWS_STATS_REQUESTED';
exports.REVIEWS_STATS_REQUESTED = REVIEWS_STATS_REQUESTED;
var REVIEWS_STATS_RECEIVED = 'REVIEWS_STATS_RECEIVED';
exports.REVIEWS_STATS_RECEIVED = REVIEWS_STATS_RECEIVED;
var REVIEWS_STATS_FAILED = 'REVIEWS_STATS_FAILED';
exports.REVIEWS_STATS_FAILED = REVIEWS_STATS_FAILED;
var REVIEWS_STATS_RESET = 'REVIEWS_STATS_RESET';
exports.REVIEWS_STATS_RESET = REVIEWS_STATS_RESET;
var REVIEW_HELPFUL_REQUESTED = 'REVIEW_HELPFUL_REQUESTED';
exports.REVIEW_HELPFUL_REQUESTED = REVIEW_HELPFUL_REQUESTED;
var REVIEW_HELPFUL_RECEIVED = 'REVIEW_HELPFUL_RECEIVED';
exports.REVIEW_HELPFUL_RECEIVED = REVIEW_HELPFUL_RECEIVED;
var REVIEW_HELPFUL_FAILED = 'REVIEW_HELPFUL_FAILED';
exports.REVIEW_HELPFUL_FAILED = REVIEW_HELPFUL_FAILED;
var REVIEW_REPORT_REQUESTED = 'REVIEW_REPORT_REQUESTED';
exports.REVIEW_REPORT_REQUESTED = REVIEW_REPORT_REQUESTED;
var REVIEW_REPORT_RECEIVED = 'REVIEW_REPORT_RECEIVED';
exports.REVIEW_REPORT_RECEIVED = REVIEW_REPORT_RECEIVED;
var REVIEW_REPORT_FAILED = 'REVIEW_REPORT_FAILED';
exports.REVIEW_REPORT_FAILED = REVIEW_REPORT_FAILED;
var REVIEW_REPORT_REPLY_REQUESTED = 'REVIEW_REPORT_REPLY_REQUESTED';
exports.REVIEW_REPORT_REPLY_REQUESTED = REVIEW_REPORT_REPLY_REQUESTED;
var REVIEW_REPORT_REPLY_RECEIVED = 'REVIEW_REPORT_REPLY_RECEIVED';
exports.REVIEW_REPORT_REPLY_RECEIVED = REVIEW_REPORT_REPLY_RECEIVED;
var REVIEW_REPORT_REPLY_FAILED = 'REVIEW_REPORT_REPLY_FAILED';
exports.REVIEW_REPORT_REPLY_FAILED = REVIEW_REPORT_REPLY_FAILED;
var DETAILS_MORE_APPS_FETCH_REQUESTED = 'DETAILS_MORE_APPS_FETCH_REQUESTED';
exports.DETAILS_MORE_APPS_FETCH_REQUESTED = DETAILS_MORE_APPS_FETCH_REQUESTED;
var DETAILS_MORE_APPS_FETCH_RECEIVED = 'DETAILS_MORE_APPS_FETCH_RECEIVED';
exports.DETAILS_MORE_APPS_FETCH_RECEIVED = DETAILS_MORE_APPS_FETCH_RECEIVED;
var DETAILS_MORE_APPS_FETCH_FAILED = 'DETAILS_MORE_APPS_FETCH_FAILED';
exports.DETAILS_MORE_APPS_FETCH_FAILED = DETAILS_MORE_APPS_FETCH_FAILED;
var DETAILS_MORE_APPS_RESET = 'DETAILS_MORE_APPS_RESET';
exports.DETAILS_MORE_APPS_RESET = DETAILS_MORE_APPS_RESET;


//////////////////
// WEBPACK FOOTER
// ./js/actions/ActionTypes.js
// module id = 47
// module chunks = 209 210 211 212